<template>
  <div class="sales-script-upsell w-100">
    <div class="container py-5">
      <div class="upsell-card mx-auto">
        <!-- ─── Playbook: Sales Script upsell (i18n) ─── -->
        <template v-if="upsellVariant === 'playbook'">
          <!-- Premium feature badge -->
          <div class="text-center">
            <span class="premium-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 16.8 5.8 21.3l2.4-7.4L2 9.4h7.6z" />
              </svg>
              <span>{{ $t("lang.contactWithYourAC.premiumBadge") }}</span>
            </span>
          </div>

          <!-- Title and subtitle -->
          <div class="text-center mt-3">
            <h1 class="upsell-title">
              {{ $t("lang.contactWithYourAC.title") }}
            </h1>
            <p class="upsell-subtitle mx-auto">
              {{ $t("lang.contactWithYourAC.subtitle") }}
            </p>
          </div>

          <!-- Feature cards 2x2 grid -->
          <div class="row upsell-features-row mt-4">
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.feature1Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.feature1Description") }}
                </p>
              </div>
            </div>
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" />
                    <circle cx="12" cy="12" r="6" />
                    <circle cx="12" cy="12" r="2" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.feature2Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.feature2Description") }}
                </p>
              </div>
            </div>
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    <polyline points="9 12 11 14 15 10" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.feature3Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.feature3Description") }}
                </p>
              </div>
            </div>
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M12 2v4" />
                    <path d="M12 18v4" />
                    <path d="M4.93 4.93l2.83 2.83" />
                    <path d="M16.24 16.24l2.83 2.83" />
                    <path d="M2 12h4" />
                    <path d="M18 12h4" />
                    <path d="M4.93 19.07l2.83-2.83" />
                    <path d="M16.24 7.76l2.83-2.83" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.feature4Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.feature4Description") }}
                </p>
              </div>
            </div>
          </div>

          <!-- What's included section -->
          <div class="included-section mt-4">
            <p class="included-label">
              {{ $t("lang.contactWithYourAC.includedSectionLabel") }}
            </p>
            <div class="included-stack">
              <div class="included-item">
                <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <p class="included-text">
                  <span class="included-text-label">{{
                    $t("lang.contactWithYourAC.included1Label")
                  }}</span>
                  {{ $t("lang.contactWithYourAC.included1Body") }}
                </p>
              </div>
              <div class="included-item">
                <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <p class="included-text">
                  <span class="included-text-label">{{
                    $t("lang.contactWithYourAC.included2Label")
                  }}</span>
                  {{ $t("lang.contactWithYourAC.included2Body") }}
                </p>
              </div>
              <div class="included-item">
                <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <p class="included-text">
                  <span class="included-text-label">{{
                    $t("lang.contactWithYourAC.included3Label")
                  }}</span>
                  {{ $t("lang.contactWithYourAC.included3Body") }}
                </p>
              </div>
              <div class="included-item">
                <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <p class="included-text">
                  <span class="included-text-label">{{
                    $t("lang.contactWithYourAC.included4Label")
                  }}</span>
                  {{ $t("lang.contactWithYourAC.included4Body") }}
                </p>
              </div>
              <div class="included-item">
                <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <p class="included-text">
                  <span class="included-text-label">{{
                    $t("lang.contactWithYourAC.included5Label")
                  }}</span>
                  {{ $t("lang.contactWithYourAC.included5Body") }}
                </p>
              </div>
            </div>
          </div>
        </template>

        <!-- ─── AI Meeting Replays upsell ─── -->
        <template v-else-if="upsellVariant === 'ai-replay'">
          <div class="text-center">
            <span class="premium-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 16.8 5.8 21.3l2.4-7.4L2 9.4h7.6z" />
              </svg>
              <span>{{ $t("lang.contactWithYourAC.premiumBadge") }}</span>
            </span>
          </div>

          <div class="text-center mt-3">
            <h1 class="upsell-title">
              {{ $t("lang.contactWithYourAC.aiReplayTitle") }}
            </h1>
            <p class="upsell-subtitle mx-auto">
              {{ $t("lang.contactWithYourAC.aiReplaySubtitle") }}
            </p>
          </div>

          <div class="row upsell-features-row mt-4">
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M23 7l-7 5 7 5V7z" />
                    <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.aiReplayFeature1Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.aiReplayFeature1Description") }}
                </p>
              </div>
            </div>
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                    <polyline points="10 9 9 9 8 9" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.aiReplayFeature2Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.aiReplayFeature2Description") }}
                </p>
              </div>
            </div>
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polygon points="12 2 2 7 12 12 22 7 12 2" />
                    <polyline points="2 17 12 22 22 17" />
                    <polyline points="2 12 12 17 22 12" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.aiReplayFeature3Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.aiReplayFeature3Description") }}
                </p>
              </div>
            </div>
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <line x1="18" y1="20" x2="18" y2="10" />
                    <line x1="12" y1="20" x2="12" y2="4" />
                    <line x1="6" y1="20" x2="6" y2="14" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.aiReplayFeature4Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.aiReplayFeature4Description") }}
                </p>
              </div>
            </div>
          </div>

          <div class="included-section mt-4">
            <p class="included-label">
              {{ $t("lang.contactWithYourAC.includedSectionLabel") }}
            </p>
            <div class="row included-two-cols">
              <div class="col-md-6 mb-4 mb-md-0">
                <div class="included-stack">
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.aiReplayIncluded1") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.aiReplayIncluded2") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.aiReplayIncluded3") }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="included-stack">
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.aiReplayIncluded4") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.aiReplayIncluded5") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.aiReplayIncluded6") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="upsellVariant == 'business'">
          <div class="text-center">
            <span class="premium-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 16.8 5.8 21.3l2.4-7.4L2 9.4h7.6z" />
              </svg>
              <span>{{ $t("lang.contactWithYourAC.premiumBadge") }}</span>
            </span>
          </div>

          <div class="text-center mt-3">
            <h1 class="upsell-title">
              {{ $t("lang.contactWithYourAC.businessTitle") }}
            </h1>
            <p class="upsell-subtitle mx-auto">
              {{ $t("lang.contactWithYourAC.businessSubtitle") }}
            </p>
          </div>

          <div class="row contacts-stats-box mt-4">
            <div class="col-md-12">
              <div class="stats-title">{{ $t("lang.label.whatawaitsyoustartingnow") }}</div>
            </div>
            <div class="col-md-6">
              <div class="stat-top">
                <div class="stat-icon">
                  <svg data-v-96c4420a="" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path data-v-96c4420a="" d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle data-v-96c4420a="" cx="9" cy="7" r="4"></circle>
                    <path data-v-96c4420a="" d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path data-v-96c4420a="" d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </div>
                <div v-if="loadingTotals" class="stat-number">...</div>
                <div v-else class="stat-number">{{ totalContacts }}</div>
              </div>
              <div class="stat-label"> {{ $t("lang.label.contactsalreadypurchased") }} </div>
              <div class="divider"></div>
            </div>
            <div class="col-md-6">
              <div class="stat-top">
                <div class="stat-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <!-- base -->
                    <path d="M4 21H20" stroke="#356BB3" stroke-width="2.2" stroke-linecap="round" />

                    <!-- building outline -->
                    <path d="M7 21V6.5C7 5.67 7.67 5 8.5 5H15.5C16.33 5 17 5.67 17 6.5V21" stroke="#356BB3"
                      stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />

                    <!-- windows -->
                    <circle cx="10" cy="9" r="0.9" fill="#356BB3" />
                    <circle cx="14" cy="9" r="0.9" fill="#356BB3" />

                    <circle cx="10" cy="13" r="0.9" fill="#356BB3" />
                    <circle cx="14" cy="13" r="0.9" fill="#356BB3" />

                    <circle cx="10" cy="17" r="0.9" fill="#356BB3" />
                    <circle cx="14" cy="17" r="0.9" fill="#356BB3" />
                  </svg>
                </div>
                <div v-if="loadingTotals" class="stat-number">...</div>
                <div v-else class="stat-number">{{ totalBusiness }}</div>
              </div>
              <div class="stat-label"> {{ $t("lang.label.engagedcompanies") }} </div>
            </div>
          </div>


          <div class="row upsell-features-row mt-4">
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.businessFeature1Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.businessFeature1Description") }}
                </p>
              </div>
            </div>
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M22 12a10 10 0 1 1-5.93-9.14" />
                    <path d="M22 4 12 14.01l-3-3" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.businessFeature2Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.businessFeature2Description") }}
                </p>
              </div>
            </div>
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <line x1="18" y1="20" x2="18" y2="10" />
                    <line x1="12" y1="20" x2="12" y2="4" />
                    <line x1="6" y1="20" x2="6" y2="14" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.businessFeature3Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.businessFeature3Description") }}
                </p>
              </div>
            </div>
            <div class="col-md-6 upsell-feature-col">
              <div class="feature-card h-100">
                <div class="feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </div>
                <p class="feature-title">
                  {{ $t("lang.contactWithYourAC.businessFeature4Title") }}
                </p>
                <p class="feature-description">
                  {{ $t("lang.contactWithYourAC.businessFeature4Description") }}
                </p>
              </div>
            </div>
          </div>

          <div class="included-section mt-4">
            <p class="included-label">
              {{ $t("lang.contactWithYourAC.businessIncludedSectionLabel") }}
            </p>
            <div class="row included-two-cols">
              <div class="col-md-6 mb-4 mb-md-0">
                <div class="included-stack">
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded1") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded2") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded3") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded4") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded5") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded6") }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="included-stack">
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded7") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded8") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded9") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded10") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded11") }}
                    </p>
                  </div>
                  <div class="included-item">
                    <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <p class="included-text included-text-plain">
                      {{ $t("lang.contactWithYourAC.businessIncluded12") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- CTA -->
        <div class="text-center mt-4">
          <button type="button" class="btn-contact-am" :disabled="loading" @click="openModal('contact-with-your-am')">
            {{ buttonName }}
          </button>
          <p class="cta-helper mt-2 mb-0">
            {{ $t("lang.contactWithYourAC.ctaHelper") }}
          </p>
        </div>
      </div>
    </div>
    <Modal name="contact-with-your-am" :size="'30'" width="100%" :close="true" :scrollable="false"
      @opened="onAccountManagerModalOpened">
      <AccountManagerModal ref="accountManagerCard" :name="AmInfo.name" :email="amContactEmail" :phone="amContactPhone"
        :photoUrl="AmInfo.avatar" />
    </Modal>
  </div>
</template>

<script>
import { clientsService } from "@/_services";
import Modal from "@/components/Common/Modal.vue";
import AccountManagerModal from "@/components/Common/AccountManagerModal.vue";
import { usersService } from "@/_services";

export default {
  name: "ContactWithYourAM",
  components: {
    Modal,
    AccountManagerModal,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      AmInfo: {},
      loading: false,
      loadingTotals: true,
      totalContacts: "",
      totalBusiness: ""
    };
  },
  computed: {
    upsellVariant() {
      return this.$route.path === "/ai-meetings-replay"
        ? "ai-replay"
        : this.$route.path === "/playbook"
          ? "playbook"
          : "business";
    },
    buttonName() {
      if (this.upsellVariant === "ai-replay" || this.upsellVariant === "business") {
        return this.$t("lang.contactWithYourAC.ctaButton2");
      }
      return this.$t("lang.contactWithYourAC.ctaButton1");
    },
    amContactEmail() {
      const a = this.AmInfo;
      if (!a || typeof a !== "object" || Array.isArray(a)) return "";
      const keys = ["email", "user_email", "mail", "e_mail", "contact_email", "userEmail"];
      for (let i = 0; i < keys.length; i++) {
        const v = a[keys[i]];
        if (v != null && String(v).trim() !== "") return String(v).trim();
      }
      return "";
    },
    amContactPhone() {
      const a = this.AmInfo;
      if (!a || typeof a !== "object" || Array.isArray(a)) return "";
      const keys = ["phone", "telephone", "tel", "mobile", "cellphone", "user_phone", "phone_number"];
      for (let i = 0; i < keys.length; i++) {
        const v = a[keys[i]];
        if (v != null && String(v).trim() !== "") return String(v).trim();
      }
      return "";
    },
  },
  created() {
    this.getInfoAM();

    if(this.upsellVariant == 'business'){
      usersService.getClientTotalContacts(this.clientId).then((res) => {
        if (res) {
          this.totalContacts = res.total_contacts
          this.totalBusiness = res.total_business

          // this.totalContacts = this.totalContacts.toLocaleString('fr-FR'); 
          // this.totalBusiness = this.totalBusiness.toLocaleString('fr-FR'); 
          
          this.totalContacts = this.totalContacts.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          this.totalBusiness = this.totalBusiness.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          this.loadingTotals = false;
        }
      });
    }
  },
  methods: {
    openModal(name) {
      this.$modal.show(name);
    },
    onAccountManagerModalOpened() {
      this.$nextTick(() => {
        const card = this.$refs.accountManagerCard;
        if (card && typeof card.resetCopyState === "function") {
          card.resetCopyState();
        }
      });
    },
    closeModal(name) {
      this.$modal.hide(name);
    },
    getInfoAM() {
      this.loading = true;
      clientsService.getAMbyClient(this.clientId).then(
        (response) => {
          this.AmInfo = response.result || {};
          console.log("AM Info:", this.AmInfo);
        },
      )
        .catch((error) => {
          console.error("Error fetching AM info:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
/* Brand tokens */
.sales-script-upsell {
  --ol-primary: #4b4be1;
  --ol-primary-bg: #eeeeff;
  --ol-text-primary: #1f2937;
  --ol-text-secondary: #6b7280;
  --ol-text-tertiary: #9ca3af;
  --ol-surface: #ffffff;
  --ol-surface-soft: #f7f7fb;
  --ol-border: rgba(0, 0, 0, 0.08);
}

/* Outer card (+20% vs diseño base ~760px → 912px) */
.upsell-card {
  max-width: 912px;
  background: var(--ol-surface);
  border: 0.5px solid var(--ol-border);
  border-radius: 12px;
  padding: 3rem 2.5rem;
}

/* Premium badge */
.premium-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--ol-primary-bg);
  color: var(--ol-primary);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
}

/* Title */
.upsell-title {
  font-size: 28px;
  font-weight: 500;
  letter-spacing: -0.5px;
  color: var(--ol-text-primary);
  margin: 0 0 0.75rem;
}

.upsell-subtitle {
  font-size: 16px;
  color: var(--ol-text-secondary);
  line-height: 1.6;
  max-width: 648px;
  margin: 0;
}

.upsell-feature-col:not(:last-child) {
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .upsell-feature-col {
    margin-bottom: 0;
  }

  .upsell-feature-col:nth-child(1),
  .upsell-feature-col:nth-child(2) {
    margin-bottom: 1rem;
  }
}

.included-stack {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

/* Feature card */
.feature-card {
  background: var(--ol-surface-soft);
  border-radius: 12px;
  padding: 1.25rem;
  text-align: left;
}

.feature-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: var(--ol-primary-bg);
  color: var(--ol-primary);
  margin-bottom: 12px;
}

.feature-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--ol-text-primary);
  margin: 0 0 4px;
}

.feature-description {
  font-size: 13px;
  color: var(--ol-text-secondary);
  line-height: 1.5;
  margin: 0;
}

/* Included section */
.included-section {
  background: var(--ol-surface-soft);
  border-radius: 12px;
  padding: 1.5rem;
  text-align: left;
}

.included-label {
  font-size: 11px;
  color: var(--ol-primary);
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-weight: 500;
  margin: 0 0 14px;
}

.included-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.included-text {
  font-size: 13px;
  line-height: 1.5;
  color: var(--ol-text-primary);
  margin: 0;
}

.included-text-label {
  font-weight: 500;
}

.check-icon {
  flex-shrink: 0;
  margin-top: 4px;
  color: var(--ol-primary);
}

/* CTA */
.btn-contact-am {
  background: var(--ol-primary);
  color: #ffffff;
  border: none;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: filter 0.15s ease, transform 0.05s ease;
}

.btn-contact-am:hover {
  filter: brightness(0.95);
}

.btn-contact-am:active {
  transform: scale(0.98);
}

.btn-contact-am:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
}

.btn-contact-am:disabled:hover,
.btn-contact-am:disabled:active {
  filter: none;
  transform: none;
}

.cta-helper {
  font-size: 12px;
  color: var(--ol-text-tertiary);
}

/* Responsive tweak */
@media (max-width: 575.98px) {
  .upsell-card {
    padding: 2rem 1.25rem;
  }

  .upsell-title {
    font-size: 24px;
  }
}

.contacts-stats-box {
  background: #dfe8f5;
  border-radius: 12px;
  padding: 40px 60px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  text-align: center;
  color: var(--blue);
}

.contacts-stats-box .stats-title {
  text-align: center;
  color: #2f63b3;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 40px;
  text-transform: uppercase;
  position:relative;
}

.contacts-stats-box .stat-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
}

.contacts-stats-box .stat-icon {
  font-size: 36px;
  color: #2f63b3;
}

.contacts-stats-box .stat-number {
  font-size: 48px;
  line-height: 1;
  font-weight: 700;
  color: #2f63b3;
}

.contacts-stats-box .stat-label {
  margin-top: 16px;
  font-size: 18px;
  color: #333;
  font-weight: 400;
}

.contacts-stats-box .divider {
  width: 1px;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  right: 0px;
  top: 0px;
  height: 100%;
}
</style>
